var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStackedBarChart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8E9664E7-F4D8-4921-A536-FA584E453039") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Chart/StackedBar",
    fill: "#666666"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19,0 L18,0 C17.448,0 17,0.448 17,1 L17,18.997 L16,18.997 L16,7 C16,6.448 15.552,6 15,6 L14,6 C13.448,6 13,6.448 13,7 L13,18.997 L9,18.998 L9,10 C9,9.448 8.552,9 8,9 L7,9 C6.448,9 6,9.448 6,10 L6,18.999 L5,18.999 L5,12 C5,11.448 4.552,11 4,11 L3,11 C2.448,11 2,11.448 2,12 L2,19 L1,19 L1,0 L0,0 L0,20 L20,20 L20,19.996 L20,1 C20,0.448 19.552,0 19,0 L19,0 Z M4,12 L4,18.999 L4,19 L3,19 L3,19 L3,12 L4,12 L4,12 Z M8,10 L8,18.998 L8,19 L7,19 L7,18.999 L7,10 L8,10 L8,10 Z M15,7 L15,18.997 L15,19 L14,19 L14,18.997 L14,7 L15,7 L15,7 Z M19,1 L19,19 L18,19 L18,18.997 L18,1 L19,1 Z",
    id: "Fill-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackedBarChart);
export default __webpack_public_path__ + "static/media/StackedBarChart.79508fa8018982d0be617dab89169b70.svg";
export { ForwardRef as ReactComponent };